/**
 * ARTMiE intelligent cart recommendations.
 * Shows the theme's OWN native "Preporučeni proizvodi" (recommended-products) section for the
 * cart's main item — so the cards look exactly like everywhere else, keep their real add-to-cart,
 * and inherit the theme's out-of-stock filtering. The product's recommendations come from our
 * pooled cross-country co-purchase (custom.recommended_products), so they're basket-relevant.
 * Falls back to the theme's static cart section if anything is missing.
 *
 * Config (snippet): window.AMH_CART_RECO = { market, apiBase, currency }  (apiBase unused here)
 */
(function () {
  "use strict";
  // Stale add-on/gag SKUs that must never be recommended (until the metafields are re-synced
  // with the exclude rules). Matched by the SKU suffix in the handle.
  var GAG = /myhsurprise|myhtip|mystery-proizvod|spakirati/i;
  var applying = false;

  // ONLY act on the cart page — the product-list selector below also matches the homepage
  // bestsellers section, so without this guard the widget would hijack the homepage.
  function onCartPage() {
    try { if (/\/cart(\/|$|\?|#)/.test(window.location.pathname)) return true; } catch (e) { /* ignore */ }
    return !!document.querySelector('[id^="shopify-section"][id*="cart-section"], [id^="shopify-section"][id*="main-cart"], cart-items, cart-items-component');
  }

  function cartProductList() {
    // the theme's static cart "you may also like" product-list section
    return document.querySelector('[id^="shopify-section"][id*="product_list"]');
  }
  function alreadyOurs() {
    return document.querySelector('[id^="shopify-section"][id*="recommended_products"][data-amh-cc="1"]');
  }

  // pick the most expensive line as the cross-sell anchor
  function anchorHandle(cart) {
    var items = (cart.items || []).filter(function (i) { return i && i.handle; });
    if (!items.length) return null;
    items.sort(function (a, b) { return (b.price || 0) - (a.price || 0); });
    return items[0].handle;
  }

  function cleanCards(section) {
    section.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var href = a.getAttribute("href") || "";
      var soldOut = false;
      var card = a.closest("product-card, .resource-list__item, li");
      if (card) soldOut = /rasprodano|sold\s*out|nedostupno|nema na (stanju|zalihi)|ausverkauft|vyprodáno|elfogyott|epuizat|wyprzedan/i.test(card.textContent || "");
      if ((GAG.test(href) || soldOut) && card) card.remove();
    });
    return section;
  }

  function inject(section) {
    var target = cartProductList();
    if (!target) return false;
    var node = document.importNode(section, true);
    node.setAttribute("data-amh-cc", "1");
    applying = true;
    target.parentNode.replaceChild(node, target);
    // let the theme initialise the freshly-injected section (carousel + add-to-cart)
    var sid = node.id ? node.id.replace("shopify-section-", "") : "";
    try { document.dispatchEvent(new CustomEvent("shopify:section:load", { bubbles: true, detail: { sectionId: sid } })); } catch (e) { /* ignore */ }
    setTimeout(function () { applying = false; }, 100);
    return true;
  }

  function run() {
    if (!onCartPage() || alreadyOurs() || !cartProductList()) return;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var h = anchorHandle(cart);
        return h ? fetch("/products/" + h) : null;
      })
      .then(function (r) { return r ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var rec = doc.querySelector('[id^="shopify-section"][id*="recommended_products"]');
        if (!rec) return;
        cleanCards(rec);
        var n = new Set(Array.from(rec.querySelectorAll('a[href*="/products/"]')).map(function (a) { return (a.getAttribute("href") || "").split("?")[0]; })).size;
        if (n < 3) return; // too few → keep the theme's static bestsellers fallback
        inject(rec);
      })
      .catch(function () { /* leave the native static section on any error */ });
  }

  // The theme re-renders the cart sections on cart change (which restores the static section);
  // re-apply, debounced and guarded against our own writes.
  var t = null;
  function schedule() { if (applying) return; clearTimeout(t); t = setTimeout(run, 300); }
  function boot() {
    run();
    try {
      var host = document.querySelector("#MainContent, main") || document.body;
      new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    } catch (e) { /* ignore */ }
    ["cart:refresh", "cart:updated", "cart:change", "on:cart:update"].forEach(function (ev) { document.addEventListener(ev, schedule); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
